import core from "@gtmhub/core/module";
import files from "@gtmhub/files/module";

import { AttachmentService } from "./services/attachmentService";
import { AttachmentsComponent } from "./components/attachments";
import { AttachmentComponent } from "./components/attachment";
import { PreviewImageService, PreviewImageCtrl } from "./components/preview-image/preview-image";

const mod = angular.module("attachments", [core, files]);
mod.service("AttachmentService", AttachmentService);
mod.service("PreviewImageService", PreviewImageService);
mod.controller("PreviewImageCtrl", PreviewImageCtrl);
mod.component("ghAttachments", AttachmentsComponent);
mod.component("ghAttachment", AttachmentComponent);

export default mod.name;
